const FLAG = 'FLAG{Dungeons_1s_5o_3vil}';
export default FLAG;
